<svelte:options customElement={{
  tag: "page-header",
  shadow:"none",
  props: {
    caption: { type: "String" },
    icon: {type : "String"},
    label: { type: "String" },
    text:  { type: "String" },
    single: {type :"String"}
  }
}} />

<script>
  // 1. USPを表示するかどうかの判定 (文字列 "true" もしくは booleanの true を許容)
  const isSingleActive = $derived(single === "true" || single === true);

  let {
    caption = "",
    text = "",
    label = "",
    icon = "",
    single = false
  } = $props();

</script>

<div class={isSingleActive ? "spacing:bottom:40" : "spacing:bottom:0"}>
  <h1 class="owd-page-header">
    {#if caption.length !== 0}
      <span class="owd-information spacing:bottom:8">{caption}</span>
    {/if}
    <span class="owd-page-header-content">
      {#if icon && label.length !== 0}
        <span class="owd-servicesticker">
          <img class="owd-servicesticker-icon" src="{icon}" alt="アイコン">
          <span class="owd-label text-color:white">{label}</span>
        </span>
      {/if}
      <span class="owd-text:01 owd-page-header-text">{@html text}</span>
    </span>
  </h1>
</div>

<style>
  .owd-page-header-text {
    padding: 5.5px 0;
    font-weight: 600;
  }
</style>
